export function isNever(value) {
    throw new Error(`This function should never be executed, but found this value: ${value}`);
}
